import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Pretendard, sans-serif',
    fontWeightRegular: 500, // 기본 weight (Typography variant="body1" 등)
  },
  // 원하는 컬러나 컴포넌트 커스터마이징 추가 가능
});

export default theme;
